<template>
  <div v-if="info" class="login h100 base-view flex jc-center ai-center">
    <div class="login-view base-shadow bg-fff">
      <div class="login-tab flex ai-center jc-center font-16">
        <!-- <img class="logo" src="../../../public/favicon.jpg" alt=""> -->
        <img v-if="info.collegeLogoUrl" class="logo" :src="info.collegeLogoUrl" alt="">
        {{ info.resultPageName }}
      </div>
      <div class="login-content custom-scrollbar">
        <el-form label-position="top" :model="form" ref="loginForm" class="login-form">
          <template v-for="item in showKeys">
            <el-form-item :key="item" :label="form[item].value" :prop="item+'.content'" :rules="[{
              required: true, message: form[item].placeholder, trigger: 'blur'
            }]">
              <el-input :placeholder="form[item].placeholder" v-model="form[item].content"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="验证码" prop="code" :rules="[{ required: true, message: '请输入正确的验证码', trigger: 'blur'}]">
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <el-input v-model.trim="form.code" placeholder="请输入验证码" size="small"/>
              <Identify style="margin-bottom: -17px;" :identifyCode="identifyCode"></Identify>
              <span class="el-icon-refresh-right" style="cursor: pointer;" @click="refreshCode"/>
            </div>
          </el-form-item>
          <div class=" pt-32 pb-24">
            <el-button @click="onSubmit" class="w100 base-btn" round type="primary">查 询</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import ApiInfo from '@/api/api-info.js'
import * as _localStorage from '@/utils/storage'
import Identify from "../../components/code";

export default {
  components: {Identify},
  name: 'login',
  data() {
    return {
      identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz",
      identifyCode: "",
      info: null,
      showKeys: [],
      formArr: [
        'validationField',
        'examineeName',
        'examineeIdNo',
        'userAccount',
      ],
      form: {
        validationField: {
          content: '',
          value: '',
          placeholder: '请输入',
        },
        examineeName: {
          content: '',
          value: '姓名',
          placeholder: '请输入姓名',
        },
        examineeIdNo: {
          content: '',
          value: '证件号',
          placeholder: '请输入身份证/护照/港澳通行证/台胞证',
        },
        userAccount: {
          content: '',
          value: '小艺帮账号',
          placeholder: '请输入小艺帮账号',
        },
      },
    }
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  async created() {
    const collegeId =
        this.$route.query.collegeId || _localStorage.getStorageSync('collegeId')
    if (collegeId) {
      this.$store.commit('setCollegeId', collegeId)
      await this.getInfo()
      this.info = this.$store.state.info || {}
      this.form.validationField.value = this.info.customField || ''
      this.form.validationField.palcdholder =
          '请输入' + (this.info.customField || '')
      const showKeys = this.info.validationField.split(',') || []
      if (showKeys && showKeys.length) {
        showKeys.sort()
        this.showKeys = showKeys.map((v) => this.formArr[Number(v)])
      }
    }
  },
  methods: {
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    async onSubmit() {
      try {
        let valid = await this.$refs['loginForm'].validate()
        if (valid) {
          if (this.form.code.toLowerCase() !== this.identifyCode.toLowerCase()) {
            this.refreshCode();
            return this.$message.error("验证码不正确，请重新输入！")
          }
          const param = {
            collegeId: _localStorage.getStorageSync('collegeId'),
          }
          this.showKeys.forEach((v) => {
            param[v] = this.form[v].content
          })
          const res = await ApiInfo.POSTresultList(param)
          this.$store.commit('setResultList', res || [])
          this.$store.commit('setLogin', this.form)
          this.$router.push('/list')
        }
      } catch (e) {
      }
    },
    async getInfo() {
      const collegeId = this.$store.state.collegeId
      const res = await ApiInfo.GETresultPageBycollegeId({collegeId})
      if (res) {
        this.$store.commit('setInfo', res)
      } else {
        this.$message.error('请检查链接是否正确！')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.login {
  &-view {
    width: 640px;
    min-height: 600px;
    overflow: hidden;
  }

  &-tab {
    border-bottom: 1px solid #E6E6E6;
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
    height: 70px !important;
    background-color: #409EFF;
    position: relative;

    &::after {
      width: 160px;
      height: 70px;
      content: '';
      position: absolute;
      top: 0;
      left: 70px;
      background-image: url('../../assets/head-l.png');
      background-repeat: no-repeat;
      background-size: 160px 100%;
    }

    &::before {
      width: 160px;
      height: 70px;
      content: '';
      position: absolute;
      top: 0;
      right: 161px;
      background-image: url('../../assets/head-r.png');
      background-repeat: no-repeat;
      background-size: 160px 100%;
    }

    .logo {
      height: 30px;
      width: 30px;
      border-radius: 8px;
      margin-right: 5px;
    }
  }

  &-content {
    min-height: calc(100% - 70px);
    overflow-y: auto;

    .login-form {
      height: 100%;
      padding: 32px 48px;

      .sendcode {
        text-align: center;
        width: 102px;
        position: absolute;
        right: 11px;
        bottom: 0px;
        cursor: pointer;
      }

      .sendcode::after {
        content: "";
        position: absolute;
        width: 1px;
        height: 20px;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: #d9d9d9;
      }
    }

    .forgot {
      cursor: pointer;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #0076FF;
    }
  }
}
</style>
